<template>
  <eden-confirm-dialog
    :title="'Delete Category'"
    :button-type="'danger'"
    :button-text="'Delete'"
    :button-status="deleting"
    :show.sync="setShow"
    @confirm="deleteMealCategory"
  >
    <p>
      Are you sure you want to delete this category,
      <span class="text-bold"> {{ formatText(category.category) }}?</span>
    </p>
  </eden-confirm-dialog>
</template>

<script>
import categories from "@/requests/services/meal/categories";

export default {
  name: "MealCategoryDelete",
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    category: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      deleting: false,
    };
  },
  computed: {
    setShow: {
      get() {
        return this.show;
      },
      set(value) {
        this.$emit("update:show", value);
      },
    },
  },
  methods: {
    deleteMealCategory() {
      this.deleting = true;
      categories
        .delete(this.category.id)
        .then((response) => {
          if (response.data.status) {
            this.deleting = false;
            this.$emit("success");
            this.setShow = false;
          }
        })
        .catch((error) => {
          this.$message.error(error.response.data.message);
          this.deleting = false;
          this.setShow = false;
        });
    },
  },
};
</script>

<style scoped lang="scss"></style>
